<template>
  <section id="testimonials" v-if="testimonials.length">
    <div class="container">
      <h2>Testimonials</h2>
      <div class="columns">
        <div v-for="testimonial in testimonials">
          <div v-if="testimonial.testimonial">
            <div v-html="testimonial.testimonial"></div>
            <p class="text-right">
              <strong>&mdash;<span v-html="testimonial.name"></span></strong><br>
              <span v-html="testimonial.role"></span><br>
              <span v-html="testimonial.organization"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="scrim"></div>
  </section>
</template>

<script>
export default {
  name: 'testimonials',
  props: ['testimonials']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 7rem 0 6rem;
  background-image: url('~assets/images/PFK_OurTeam_Photo3_TestimonialsBkgd_1200x730.jpg');
  background-size: cover;
  color: #fff;
  position: relative;
  .container {
    position: relative;
    z-index: 1;
  }
  .scrim {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
  }
}

.columns {
  @include media('tablet-wide') {
    display: flex;
    justify-content: space-between;
    > div {
      width: 28%;
    }
  }
}

h2 {
  margin-bottom: 3rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Testimonials.vue?ab587a80